import { makeStyles } from "@material-ui/core/styles";

const GenerateTokenStyle = makeStyles({
  tokenWrapper: {},
});

export { GenerateTokenStyle };
